import Pusher from "pusher-js";

// eslint-disable-next-line prefer-const
let pusherClient: Pusher | null = null;

export const getPusherClient = () => {
  if (pusherClient) {
    return pusherClient;
  }
  if (import.meta.env.NODE_ENV === "test") {
    return null;
  }
  if (import.meta.env.DEV) {
    Pusher.logToConsole = String(import.meta.env.VITE_PUSHER_SHOW_LOG) === "1";
  }
  pusherClient = new Pusher(import.meta.env.VITE_PUSHER_CLIENT_ID, {
    cluster: "us3",
    auth: { headers: { "X-CSRFToken": window.TF.csrf } },
    channelAuthorization: {
      endpoint: "/pusher/auth",
      transport: "ajax",
      headers: { "X-CSRFToken": window.TF.csrf },
    },
  });
  return pusherClient;
};
